module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "structure"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "epsl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("what’s your name")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("what’s your sign")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("what’s your disease")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("i saw you standing there")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("pretty as you please")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("and couldn’t help wondering")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("which of these")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("afflicts you:")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("sores around the mouth")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("or further south")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("swelling of the joints")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("or other points")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("lesions or lumps")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("blisters or bumps")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("or feeling generally queasy")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("from being too easy")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("seems everyone has something")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("and is avoiding something more")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("from the saints among us")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("to those who are hor-")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("monally imbalanced")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("and can’t get enough")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("of that funky stuff")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("i’m not casting aspersions")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("or condemning diversions")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("just a prudent inspection")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("to compare your infection")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("with mine")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("i’m in no position")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("to judge your condition")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("or condemn you")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("and call you a sleaze")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("but before we’re encased")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("in something debased")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("please tell me")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("what’s your disease")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Bill Russell, “Epitaph for the Sexual Revolution,” "), _c('i', [_vm._v("Christopher Street")]), _vm._v(", December 1982")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7766faa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-mckay-0005.vue
// module id = 66
// module chunks = 0